/** @format */
import { Address, TransactionSummary } from '.';
import { Adjustment } from './adjustment';
import { Attribute } from './attribute';
import { CustomerDetails } from './customer';
import { LineItemState } from './line-item';
import { PriceModifier } from './price-modifier';

export enum PublicTransactionQuoteState {
    UNDEFINED = 'UNDEFINED',
    REQUESTED = 'REQUESTED',
    PENDING = 'PENDING',
    DECLINED = 'DECLINED',
    ACCEPTED = 'ACCEPTED',
    UPDATED = 'UPDATED',
    ADJUSTED = 'ADJUSTED',
    COMPLETE = 'COMPLETE',
}

export enum PublicQuoteItemState {
    UNDEFINED,
    PROPOSED,
    ACCEPTED,
    DECLINED,
}

export enum QuoteExpiryState {
    UNEXPIRED = 'UNEXPIRED',
    EXPIRED = 'EXPIRED',
}

export enum QuoteSummaryState {
    PROCESSING = 'PROCESSING',
    QUOTED = 'QUOTED',
    PENDING = 'PENDING',
    FAILED = 'FAILED',
    BOOKED = 'BOOKED',
    BLOCKED = 'BLOCKED',
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface QuoteItemSummary {
    id: string;
    itemId?: string;
    modelId: number;
    condition: string;
    productId: number;
    value: number;
    lineItemId: string;
    state: PublicQuoteItemState;
    attributes: Attribute[];
    priceModifiers: PriceModifier[];
    observations: QuoteItemObservation[];
    baseValue?: number;
    adjustments?: Adjustment[];
    lineItemState?: LineItemState;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface QuoteItemObservation {
    id: string;
    observationId: number;
    tierId: number;
    adjustment: number;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface QuoteDeliveryOption {
    collectionDate?: string;
    deliveryOption: string | number | undefined;
    expectedPackageCount: number | undefined;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface QuoteSummary {
    collectionAddress: Address;
    customer: CustomerDetails;
    customerAddress: Address;
    deliveryOption: QuoteDeliveryOption;
    id: string;
    goodsInKnown: QuoteItemSummary[];
    goodsInUnknown: QuoteItemSummary[];
    goodsOut: QuoteItemSummary[];
    state: QuoteSummaryState;
    transactionId: string;
    transaction: TransactionSummary;
}
